import React from 'react'
import ReactDOM from 'react-dom/client'
import { scheduleBootPaintReportEarly } from './utils/reportBootPaintEarly'
import { installChunkLoadRetryHooks } from './utils/chunkLoadRetry'
import { installBundleSkewGuard } from './utils/bundleSkewGuard'
import App from './App.jsx'
import { installUncaughtDiagnosticHooks } from './utils/diagnosticUncaught'
import { installSupportConsoleCapture } from './utils/supportConsoleCapture'
import { logWebBundleMetaOnce } from './utils/logWebBundleMeta'
import { installDurableWebStateWriteThrough } from './lib/durableWebState'
import './index.css'

installDurableWebStateWriteThrough()
scheduleBootPaintReportEarly()
installChunkLoadRetryHooks()
installBundleSkewGuard()

const maestroBuild = typeof __MAESTRO_BUILD__ !== 'undefined' ? __MAESTRO_BUILD__ : ''
try {
  window.__MAESTRO_BUILD__ = maestroBuild
} catch {
  /* ignore */
}
if (maestroBuild) {
  // eslint-disable-next-line no-console
  console.log('[Maestro] build', maestroBuild)
}
// Both hooks have interior try/catch, but guard here too so a future regression
// in their module-level code cannot abort the file before ReactDOM.render().
try {
  installUncaughtDiagnosticHooks()
  installSupportConsoleCapture()
  logWebBundleMetaOnce()
} catch (e) {
  // eslint-disable-next-line no-console
  console.error('[boot] pre-render setup failed — continuing:', e)
}
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
} else {
  console.error('[boot] #root missing — cannot mount React');
}
